import { FC } from 'react';

import { Stack } from '@mui/material';

import { SvgIconProps } from '../../../components/SvgIcon';
import Typography from '../../../components/Typography';

export interface TileDrawerHeaderLayoutProps {
  icon: FC<SvgIconProps<'svg', {}>>;
  /** @default "primary" */
  color?: 'primary' | 'warning';
  children: string;
}

const TileDrawerHeaderLayout = ({ icon: Icon, color = 'primary', children }: TileDrawerHeaderLayoutProps) => {
  return (
    <Stack direction="row" alignItems="center" gap={2}>
      <Icon size={32} />
      <Typography variant="h6Bold" component="h3" color={color}>
        {children}
      </Typography>
    </Stack>
  );
};

export default TileDrawerHeaderLayout;
